import React, { useMemo } from 'react';
import { useDocument } from '../../documents/editor/EditorContext';
import { renderToStaticMarkup } from '../../Packages/email-builder';
import HighlightedCodePanel from './helper/HighlightedCodePanel';
export default function HtmlPanel() {
    const document = useDocument();
    const code = useMemo(() => renderToStaticMarkup(document, { rootBlockId: 'root' }), [document]);
    return React.createElement(HighlightedCodePanel, { type: "html", value: code });
}
//# sourceMappingURL=HtmlPanel.js.map